/**
 * phi-newsletter-drawer
 * Form submits normally (page reloads). After reload, drawer opens with success copy when
 * form.posted_successfully? (Liquid) or URL has customer_posted=true.
 */
class PhiNewsletterDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }
    if (this.bound) return;
    this.bound = true;

    // Escape key — only close when NOT showing success screen
    this.addEventListener('keyup', (e) => {
      if (e.code === 'Escape' && !this.querySelector('[data-phi-nl-views]')?.classList.contains('phi-nl-views--success')) {
        this.close();
      }
    });

    // Overlay click — only close if the click target is the overlay itself (not bubbled from panel)
    this.querySelector('.phi-newsletter-drawer__overlay')
      ?.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) this.close();
      });

    this.bindTrigger();
    this.bindCloseButton();
    this.bindSuccessClose();
    this.bindFormActionForRedirect();

    // Auto-open after form submit + reload: Liquid sets data-auto-open when form.posted_successfully? or form.errors
    if (this.hasAttribute('data-auto-open')) this.open();

    // When posted status is in URL (e.g. ?customer_posted=true), open drawer and show success copy
    const params = typeof URLSearchParams !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    if (params && params.get('customer_posted') === 'true') {
      this.querySelector('[data-phi-nl-views]')?.classList.add('phi-nl-views--success');
      this.open();
    }
  }

  /* ── Set form action to include customer_posted=true so redirect lands with param ── */
  bindFormActionForRedirect() {
    const form = this.querySelector('#phiNlForm-PhiNewsletter');
    if (!form) return;
    form.addEventListener('submit', function () {
      const action = form.getAttribute('action') || form.action || window.location.pathname;
      const url = new URL(action, window.location.origin);
      url.searchParams.set('customer_posted', 'true');
      form.action = url.pathname + url.search;
    }, true);
  }

  /* ── Open / close ── */
  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    setTimeout(() => this.classList.add('animate', 'active'));
    this.addEventListener('transitionend', () => {
      const panel    = this.querySelector('.phi-newsletter-drawer__panel');
      const closeBtn = this.querySelector('.phi-nl-close');
      if (typeof trapFocus === 'function') trapFocus(panel, closeBtn);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  /* ── Trigger ── */
  bindTrigger() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-phi-newsletter-trigger]');
      if (!trigger) return;
      const targetId = trigger.getAttribute('data-target');
      if (!targetId?.startsWith('#')) return;
      const drawer = document.querySelector(targetId);
      if (drawer === this) { e.preventDefault(); this.open(trigger); }
    });
  }

  /* ── Close button ── */
  bindCloseButton() {
    this.querySelector('.phi-nl-close')
      ?.addEventListener('click', () => this.close());
  }

  /* ── Close button inside success screen ── */
  bindSuccessClose() {
    this.querySelector('.phi-nl-success-close')
      ?.addEventListener('click', () => this.close());
  }
}

customElements.define('phi-newsletter-drawer', PhiNewsletterDrawer);
